import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ProjectDescription = ({ descriptionKey }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="portfolio-description">
        <h2>Description</h2>
        <p>{t(descriptionKey)}</p>
      </div>
      <Link to="/work">
        <i className="bi bi-arrow-left"></i>
        {t("Back")}
      </Link>
    </>
  );
};

ProjectDescription.propTypes = {
  descriptionKey: PropTypes.string.isRequired,
};

export default ProjectDescription;
